import { Box, Typography } from "@mui/material";
import { useState } from "react";

import { CustomEventType } from "../../../constants/customEvent";
import { SlotReelSymbol } from "../../../constants/enum/slot";
import {
  SlotPayoutAnimationDuration,
  SlotPayoutSummary,
  SlotSymbolIcons,
} from "../../../constants/slot";
import useListenCustomEvent from "../../../hook/useListenCustomEvent";
import { SlotPayout } from "../../../types/SlotPayout";

import useStyles from "./index.styles";

const SlotPayTable = () => {
  const { classes } = useStyles();
  const [winningSymbol, setWinningSymbol] = useState<SlotReelSymbol | null>(
    null
  );

  useListenCustomEvent(CustomEventType.SlotWin, (event: Event) => {
    const slotPayout = (event as CustomEvent).detail as SlotPayout;

    setWinningSymbol(slotPayout.symbol);

    setTimeout(() => {
      setWinningSymbol(null);
    }, SlotPayoutAnimationDuration[slotPayout.payoutType]);
  });

  return (
    <Box className={classes.panel}>
      <Box className={classes.panelHeader}>
        <Typography className={classes.panelTitle}>PayTable</Typography>
      </Box>
      <Box className={classes.panelBody}>
        <Box className={classes.payTableHeader}>
          <Typography>Symbols</Typography>
          <Typography>2x</Typography>
          <Typography>3x</Typography>
        </Box>

        <Box className={classes.payTableList}>
          {SlotPayoutSummary.map((reward, index) => {
            const isWinningSymbol = reward.symbol === winningSymbol;
            return (
              <Box
                className={`${classes.payTableItem} ${
                  isWinningSymbol ? classes.highlight : ""
                }`}
                key={index}
              >
                <Box className={classes.paySymbols}>
                  <Box
                    component={"img"}
                    src={SlotSymbolIcons[reward.symbol]}
                  ></Box>
                  <Box
                    component={"img"}
                    src={SlotSymbolIcons[reward.symbol]}
                  ></Box>
                  <Box
                    component={"img"}
                    src={SlotSymbolIcons[reward.symbol]}
                  ></Box>
                </Box>
                <Typography>{reward.twoX}x</Typography>
                <Typography>{reward.threeX}x</Typography>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default SlotPayTable;
